export const SCHEMA_VERSIONS = Object.freeze({
  ORGANIZATION: 1,
  VESSEL: 1,
  VESSEL_PARTICULARS: 1,
  TANK: 1,
  TANK_HISTORY_ENTRY: 1,
  VOYAGE: 1,
  TRIP: 1,
  TRIP_CARGO: 1,
});
